/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PulseHAApiService } from '../http/pulseHA.api.service';

@Injectable()
export class PulseHAGlobalConfigResolver {
    constructor(
        private pulseHA: PulseHAApiService
    ) {
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public resolve(route: ActivatedRouteSnapshot) {
        return this.pulseHA.getConfigGlobal();
    }
}
